import BestAnswerDesktop from './best-answer-desktop';
import BestAnswerMobile from './best-answer-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(BestAnswerMobile, BestAnswerDesktop);
